export class BreadCrumbs {
  constructor(difference) {
    this.width = 600
    this.height = 40
    this.top = 10
    this.left = 10
    this.innerElement = "cxBreadCrumbs"

    this.sourceData = [
      {
        label: "首页",
        path: "/"
      },
      {
        label: "课程中心",
        path: "/"
      },
      {
        label: "课程详情"
      }
    ]

    this.separatorType = "str" // str : "/" , icon
    ;(this.iconSrc = ""), (this.iconType = "img") // img,icon 图片和字体图标
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "#444444"

    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.lineHeight = 14
    this.fontWeight = 600
    this.textDecoration = "none"
    this.letterSpacing = 0
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.fontStyle = "normal"
    this.color = "rgba(0,0,0,0.8)"
    this.textIsThemeColor = false
    this.contentHasLimit = false
    this.textLimitWords = 4
    this.textOverflowEllipsis = false

    this.bgColor = "rgba(61, 130, 242,0)"
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg"
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.rotate = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#3D82F2"
    this.borderWidth = 0
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = ["rgba(61, 130, 242, 0.5)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.opacity = 1
    this.background = []
    this.textPaddingTypeFlag = 2
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0

    this.hoverFontFamily = "sans-serif"
    this.hoverFontSize = 14
    this.hoverLineHeight = 14
    this.hoverFontWeight = 600
    this.hoverTextDecoration = "none"
    this.hoverLetterSpacing = 0
    this.hoverTextAlign = "left"
    this.hoverWritingMode = "horizontal-tb"
    this.hoverFontStyle = "normal"
    this.hoverColor = "rgba(0, 0, 0, 0.4)"
    this.hoverTextIsThemeColor = false

    this.activeFontFamily = "sans-serif"
    this.activeFontSize = 14
    this.activeLineHeight = 14
    this.activeFontWeight = 600
    this.activeTextDecoration = "none"
    this.activeLetterSpacing = 0
    this.activeTextAlign = "left"
    this.activeWritingMode = "horizontal-tb"
    this.activeFontStyle = "normal"
    this.activeColor = "rgba(0, 0, 0, 0.4)"
    this.activeTextIsThemeColor = false

    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
